export const ACTIVE_LOCALES = ['GB', 'US', 'IE', 'AU'] as const
